import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const blogPosts = [
  {
    id: 1,
    title: "Comment améliorer votre taux de confirmation",
    excerpt: "Découvrez nos meilleures pratiques pour optimiser vos confirmations de commandes COD...",
    image: "/blog/confirmation-rate.svg",
    date: "10 Feb 2025",
    category: "Guide"
  },
  {
    id: 2,
    title: "Les nouveautés WhatsApp Business",
    excerpt: "WhatsApp Business introduit de nouvelles fonctionnalités pour la confirmation de commandes...",
    image: "/blog/whatsapp-business.svg",
    date: "8 Feb 2025",
    category: "Actualités"
  },
  {
    id: 3,
    title: "Réduire les retours grâce à l'IA",
    excerpt: "L'intelligence artificielle au service de la prédiction des retours de commandes...",
    image: "/blog/ai-returns.svg",
    date: "5 Feb 2025",
    category: "Innovation"
  }
];

const BlogSection = () => {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mx-auto max-w-2xl text-center"
        >
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Blog & Actualités
          </h2>
          <p className="mt-2 text-lg leading-8 text-gray-600">
            Découvrez nos derniers articles, guides et actualités sur la gestion des commandes e-commerce.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3"
        >
          {blogPosts.map((post) => (
            <article key={post.id} className="flex flex-col items-start">
              <div className="relative w-full">
                <img
                  src={post.image}
                  alt={post.title}
                  className="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]"
                />
                <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
              </div>
              <div className="max-w-xl">
                <div className="mt-8 flex items-center gap-x-4 text-xs">
                  <time dateTime={post.date} className="text-gray-500">
                    {post.date}
                  </time>
                  <span className="relative z-10 rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100">
                    {post.category}
                  </span>
                </div>
                <div className="group relative">
                  <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                    <Link to={`/blog/${post.id}`}>
                      <span className="absolute inset-0" />
                      {post.title}
                    </Link>
                  </h3>
                  <p className="mt-5 line-clamp-3 text-sm leading-6 text-gray-600">{post.excerpt}</p>
                </div>
              </div>
            </article>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default BlogSection;
